/** @flow */

import type { State } from "@store/reducers";
import type {
  MySavedReports,
  DefaultReports,
  AbsenceMonitoringReportViewState,
} from "@modules/reporting/reducer/reports/absence-monitoring/types";

import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";

export const defaultReports = (state: State): Array<DefaultReports> =>
  state.reporting.reports.absenceMonitoring.defaultReports;

export const mySavedReports = (state: State): Array<MySavedReports> =>
  state.reporting.reports.absenceMonitoring.mySavedReports;

export const getReportData = (state: State): Array<Object> =>
  state.reporting.reports.absenceMonitoring.reportData.content;
export const getCurrentReport = (state: State): ?Object =>
  (state.reporting.reports.absenceMonitoring.currentReport || {}).report;

export const getCurrentCharts = (state: State): ?Object =>
  state.reporting.reports.absenceMonitoring.currentCharts;

export const getAbsenceMonitoringFiltersSchema = (state: State): ?Object =>
  state.reporting.reports.absenceMonitoring.absenceMonitoringFiltersSchema;

export const getAbsenceMonitoringDetailsPagination = (state: State): PaginationExtendedType =>
  getPagination(state.reporting.reports.absenceMonitoring.reportData);

export const getTotalElementsAbsenceMonitoringDetails = (state: State) =>
  state.reporting.reports.absenceMonitoring.reportData.totalElements;

export const getReportToSave = (state: State): ?Object =>
  state.reporting.reports.absenceMonitoring.reportToSave;

export const getViewState = (state: State): AbsenceMonitoringReportViewState =>
  state.reporting.reports.absenceMonitoring.viewState;

export const isLoading = (state: State): boolean =>
  state.reporting.reports.absenceMonitoring.requestsInProgress > 0;

export const isReportGenerateInProgress = (state: State): boolean =>
  state.reporting.reports.absenceMonitoring.reportGenerateInProgress > 0;
